// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "us-east-1",
    "aws_content_delivery_bucket": "admin.joshstir.com",
    "aws_content_delivery_bucket_region": "us-east-1",
    "aws_content_delivery_url": "http://admin.joshstir.com.s3-website-us-east-1.amazonaws.com",
    "aws_cognito_identity_pool_id": "us-east-1:4509dba3-5b3a-49bb-9c36-17d6fc88cca0",
    "aws_cognito_region": "us-east-1",
    "aws_user_pools_id": "us-east-1_6e8XYYNPl",
    "aws_user_pools_web_client_id": "1r38avr06eij2v900d3796qtna",
    "oauth": {}
};


export default awsmobile;
